import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import ArrowRightIcon from '@wix/da-ds/pkg/Icons/16x16/ArrowRight';
import ArrowLeftIcon from '@wix/da-ds/pkg/Icons/16x16/ArrowLeft';
import s from './SliderArrowButton.scss';
const SliderArrowButton = (_param)=>{
    var { direction, onClick, className } = _param, rest = _object_without_properties(_param, [
        "direction",
        "onClick",
        "className"
    ]);
    const { t } = useTranslation('dreamup');
    return /*#__PURE__*/ React.createElement(IconButton, _object_spread({
        size: "small",
        variant: "main",
        "aria-label": direction === 'left' ? t('dreamup.sliderButtons.left') : t('dreamup.sliderButtons.right'),
        icon: direction === 'left' ? ArrowLeftIcon : ArrowRightIcon,
        onClick: onClick,
        type: "button",
        className: c(s['root'], className)
    }, rest));
};
SliderArrowButton.displayName = 'SliderArrowButton';
export default SliderArrowButton;

//# sourceMappingURL=SliderArrowButton.js.map